import api from './api'

export const geographyService = {
  /**
   * Fetches all active countries
   */
  async getCountries() {
    try {
      const response = await api.get('/geography/countries')
      return response.data
    } catch (error) {
      console.error('Error fetching countries:', error)
      throw error
    }
  },

  /**
   * Fetches a country by ID
   */
  async getCountryById(id) {
    try {
      const response = await api.get(`/geography/countries/${id}`)
      return response.data
    } catch (error) {
      console.error('Error fetching country:', error)
      throw error
    }
  },

  /**
   * Fetches states/provinces of a country
   */
  async getProvincesByCountry(countryId) {
    try {
      const response = await api.get(`/geography/countries/${countryId}/provinces`)
      return response.data
    } catch (error) {
      console.error('Error fetching provinces:', error)
      throw error
    }
  },

  /**
   * Fetches a province/state by ID
   */
  async getProvinceById(id) {
    try {
      const response = await api.get(`/geography/provinces/${id}`)
      return response.data
    } catch (error) {
      console.error('Error fetching province:', error)
      throw error
    }
  },

  /**
   * Fetches countries with their provinces/states
   */
  async getCountriesWithProvinces() {
    try {
      const response = await api.get('/geography/countries-with-provinces')
      return response.data
    } catch (error) {
      console.error('Error fetching countries with provinces:', error)
      throw error
    }
  }
}
